import { useGetMediaUrlMutation } from 'src/pages/chat/slice/chatApi';

export const htmlToText = (htmlString: string) => {
  if (htmlString.length > 0) {
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = htmlString;
    return tempDiv.innerText || '';
  }
  return '';
};

export const getAssigneName = (assignUserDetail: any, assigneType: any) => {
  if (!assignUserDetail || !assigneType) return '';
  if (assigneType === 'USER') {
    const { firstName, lastName, email } = assignUserDetail;

    const fullName = [firstName, lastName].filter(Boolean).join(' ').trim();

    return fullName || email || '';
  }
  if (assigneType === 'TEAM') {
    return assignUserDetail.name;
  }
  return '';
};

export function getFlexibleUtcDateRange(startDays = 0, endDays = 0) {
  const MS_PER_DAY = 86400000;
  const now = Date.now();

  const startDate = new Date(now - startDays * MS_PER_DAY);
  const endDate = new Date(now - endDays * MS_PER_DAY);

  const from = new Date(
    startDate.getFullYear(),
    startDate.getMonth(),
    startDate.getDate()
  ).toISOString();

  const to = new Date(
    endDate.getFullYear(),
    endDate.getMonth(),
    endDate.getDate(),
    23,
    59,
    59,
    999
  ).toISOString();

  return { from, to };
}

export const getProfileUrl = (channelType: string) => {
  switch (channelType) {
    case 'WHATSAPP':
      return '/assets/icons/navbar/ic-variance-whatsapp-business.svg';
    case 'EMAIL':
      return '/assets/icons/navbar/ic-variance-mail.svg';
    case 'LIVE_CHAT':
      return '/assets/icons/navbar/ic-variance-livechat.svg';
    default:
      return '';
  }
};

export function formatDate({
  dateString,
  type = 'date',
  months,
}: {
  dateString: string;
  type: 'hours' | 'date' | 'month';
  months: string[];
}): string {
  if (type === 'hours') {
    return dateString;
  }

  if (type === 'date') {
    const dateObj = new Date(dateString);
    const day = String(dateObj.getDate()).padStart(2, '0');
    const month = months[dateObj.getMonth()];
    return `${day} ${month}`;
  }

  if (type === 'month') {
    const [yearStr, monthStr] = dateString.split('-');
    const monthIndex = parseInt(monthStr, 10) - 1;
    const month = months[monthIndex];
    return `${month} ${yearStr}`;
  }

  return dateString;
}

export function removeEmptyKeys(obj: any) {
  return Object.fromEntries(
    Object.entries(obj).filter(
      ([_, value]) => value !== null && value !== '' && value !== undefined
    )
  );
}

export const localTimeZone = Intl?.DateTimeFormat()?.resolvedOptions()?.timeZone;
